module.exports = __WEBPACK_EXTERNAL_MODULE_178__;


//////////////////
// WEBPACK FOOTER
// external "xes-frontend-ui/lib/material-content"
// module id = 178
// module chunks = 12